import request from '@api/request'

// 活动列表查询(分页)
export const getActivityDataByPage = params =>
  request.get('/activityData/getActivityDataByPage', { params })

// 我的报名(分页)
export const getSignRecordByPage = params =>
  request.get('/signRecord/getSignRecordByPage', { params })

// 活动详情查询
export const getActivityData = params =>
  request.get('/activityData/getActivityData', { params })

// 我要报名
export const addSignRecord = params =>
  request.post('/signRecord/addSignRecord', params)

// 活动签到
export const updateSignRecord = params =>
  request.post('/signRecord/updateSignRecord', params)

// 取消报名
export const deleteSignRecord = params =>
  request.post('/signRecord/deleteSignRecord', params)

// 获取海报
export const getCodeUrl = params =>
  request.get('/qrCode/getCodeUrl', { params })

// 活动埋点
export const visitActivity = params =>
  request.get('/activityData/visitActivity', { params })
